import { render, staticRenderFns } from "./DialogErrorNotification.vue?vue&type=template&id=918633b0&scoped=true&"
import script from "./DialogErrorNotification.vue?vue&type=script&lang=js&"
export * from "./DialogErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./DialogErrorNotification.vue?vue&type=style&index=0&id=918633b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918633b0",
  null
  
)

export default component.exports